const ACTION_TYPES = {
    CHANGE_CURRENT_SKU: 'CHANGE_CURRENT_SKU',
    SUBSCRIPTION: {
        TYPE: 'outOfStock',
        ACTION_TYPE: 'cancel'
    },
    UPDATE_CURRENT_PRODUCT: 'UPDATE_CURRENT_PRODUCT',
    RESET_CURRENT_PRODUCT: 'RESET_CURRENT_PRODUCT',
    UPDATE_CURRENT_PRODUCT_USER_SPECIFIC: 'UPDATE_CURRENT_PRODUCT_USER_SPECIFIC',
    UPDATE_RESERVE_ONLINE_PICK_UP_IN_STORE_DETAILS: 'UPDATE_RESERVE_ONLINE_PICK_UP_IN_STORE_DETAILS',
    UPDATE_CURRENT_SKU_IN_CURRENT_PRODUCT: 'UPDATE_CURRENT_SKU_IN_CURRENT_PRODUCT',
    UPDATE_QUANTITY_OF_CURRENT_SKU: 'UPDATE_QUANTITY_OF_CURRENT_SKU',
    HOVERED_SKU: 'HOVERED_SKU',
    TOGGLE_CUSTOM_SETS: 'TOGGLE_CUSTOM_SETS',
    CUSTOM_SETS_CHOICE_UPDATED: 'CUSTOM_SETS_CHOICE_UPDATED',
    REVIEW_FILTERS_APPLIED: 'REVIEW_FILTERS_APPLIED',
    REVIEW_FILTERS_SELECTED: 'REVIEW_FILTERS_SELECTED',
    REVIEW_SEARCH_APPLIED: 'REVIEW_SEARCH_APPLIED',
    BEAUTY_MATCH_FILTERS_TOGGLED: 'BEAUTY_MATCH_FILTERS_TOGGLED',
    VERIFIED_PURCHASER_FILTERS_TOGGLED: 'VERIFIED_PURCHASER_FILTERS_TOGGLED',
    GALLERY_FILTERS_APPLIED: 'GALLERY_FILTERS_APPLIED',
    RESET_GALLERY_FILTERS: 'RESET_GALLERY_FILTERS',
    TOGGLE_SWATCHES: 'TOGGLE_SWATCHES',
    ADD_FLASH_ON_PDP: 'ADD_FLASH_ON_PDP',
    UPDATE_RELATED_LINKS: 'UPDATE_RELATED_LINKS',
    SELECT_SORT_OPTION: 'SELECT_SORT_OPTION',
    SELECT_FILTER_OPTION: 'SELECT_FILTER_OPTION',
    PURCHASES_FILTER_OPTIONS: 'PURCHASES_FILTER_OPTIONS',
    RESTORE_PRODUCT_WITH_NO_ROPIS: 'RESTORE_PRODUCT_WITH_NO_ROPIS'
};

const UserSpecificProductUtils = require('utils/UserSpecificProduct');
const ReserveOnlinePickUpInStoreProductUtils = require('utils/ReserveOnlinePickUpInStoreProductUtils');

const initialState = {
    currentSku: null,
    currentSkuQuantity: 1,
    currentProductUserSpecificDetails: {},
    isUserSpecificReady: false
};

const reducer = function (state = initialState, action) {
    // eslint-disable-next-line object-curly-newline
    const { type, payload } = action;

    switch (type) {
        case ACTION_TYPES.RESET_CURRENT_PRODUCT: {
            const { product } = payload;
            product.brand = product.brand || {};
            Sephora.productPage.defaultSkuId = product.currentSku.skuId;

            return {
                ...initialState,
                ...product
            };
        }

        case ACTION_TYPES.CHANGE_CURRENT_SKU:
            return Object.assign({}, state, { currentSku: action.currentSku });

        case ACTION_TYPES.UPDATE_CURRENT_PRODUCT: {
            let currentProductWithUserSpecificDetails =
                UserSpecificProductUtils.addUserSpecificDetailsToProduct(
                    action.currentProduct,
                    state.currentProductUserSpecificDetails
                );
            return Object.assign({}, state, currentProductWithUserSpecificDetails);
        }

        case ACTION_TYPES.UPDATE_CURRENT_PRODUCT_USER_SPECIFIC: {
            const { currentProductUserSpecificDetails } = payload;
            const userSpecificDetails = UserSpecificProductUtils.addUserSpecificDetailsToProduct(state, currentProductUserSpecificDetails);

            return {
                ...userSpecificDetails,
                currentProductUserSpecificDetails
            };
        }

        case ACTION_TYPES.UPDATE_RESERVE_ONLINE_PICK_UP_IN_STORE_DETAILS: {
            let productWithRopisDetails = ReserveOnlinePickUpInStoreProductUtils.addReserveOnlinePickUpInStoreDetailsToProduct(
                Object.assign({}, state),
                action.reserveOnlinePickUpInStoreProductDetails
            );

            let properties = {
                ...productWithRopisDetails,
                ropisProduct: Object.assign({}, productWithRopisDetails)
            };

            if (!state.pickupMessage) {
                properties.noRopisProduct = Object.assign({}, state);
            }

            return Object.assign({}, state, properties);
        }

        case ACTION_TYPES.RESTORE_PRODUCT_WITH_NO_ROPIS: {
            // TODO ROPIS: noRopisProduct saves as currentSku the one the user has selected (obviously),
            // but after UPDATE_RESERVE_ONLINE_PICK_UP_IN_STORE_DETAILS is called (and thus noRopisProduct
            // is created), the user can click through swatches and select another sku; so noRopisProduct
            // and currentProduct's currentSkus will not be the same.
            // We need to search through the different types of children skus and replace the current sku
            // with the actual current sku and viceversa
            let productWithoutRopisDetails = ReserveOnlinePickUpInStoreProductUtils.removeReserveOnlinePickUpInStoreDetailsToProduct(
                Object.assign({}, state),
                state.noRopisProduct
            );

            return Object.assign({}, state, productWithoutRopisDetails);
        }

        case ACTION_TYPES.UPDATE_CURRENT_SKU_IN_CURRENT_PRODUCT: {
            const { currentSku } = payload;
            const newState = {
                ...state,
                currentSku
            };

            return newState;
        }
        case ACTION_TYPES.TOGGLE_CUSTOM_SETS:
            return Object.assign({}, state, { isOpenCustomSets: action.isOpen });
        case ACTION_TYPES.ADD_FLASH_ON_PDP:
            return Object.assign({}, state, { addFlashOnPdp: action.state });
        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
